export default "__VITE_ASSET__1588cf24__"